import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../../styles/Layouts';
import { Title } from '../Ui/Title';
import { Quality } from './Quality';
import { qualities } from '../../data/qualities';
export const Qualities = () => {
  return (
    <QualitiesStyled>
      <Title title={'Qualities'} span={'Qualities'} />
      <InnerLayout>
        <div className='reviews'>
          {qualities.map((quality, index) => (
            <Quality key={index} title={quality.title} text={quality.text} />
          ))}
        </div>
      </InnerLayout>
    </QualitiesStyled>
  );
};

const QualitiesStyled = styled.section`
  .reviews {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5rem;
    width: 100%;
    @media screen and (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;
